import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  title: {
    id: 'proforma-form-security.config-button.config-modal.view-modal.title',
    defaultMessage: 'Who can view this form',
    description: 'Title for the form permission configuration modal in view only mode.'
  },
  description: {
    id: 'proforma-form-security.config-button.config-modal.view-modal.description',
    defaultMessage: 'Only specific people can view this form once submitted. <link>Read more about restricting forms</link>',
    description: 'Description for the form permission configuration modal in view only mode.'
  },
  manageButton: {
    id: 'proforma-form-security.config-button.config-modal.view-modal.manageButton',
    defaultMessage: 'Manage',
    description: 'Manage button for the form permission configuration modal in view only mode.'
  },
  manageButtonLabel: {
    id: 'proforma-form-security.config-button.config-modal.view-modal.manageButtonLabel',
    defaultMessage: 'Manage form restrictions',
    description: 'Label for Manage button for the form permission configuration modal in view only mode.'
  },
  closeButton: {
    id: 'proforma-form-security.config-button.config-modal.view-modal.cancelButton',
    defaultMessage: 'Close',
    description: 'Close button for the form permission configuration modal in view only mode.'
  },
  closeButtonLabel: {
    id: 'proforma-form-security.config-button.config-modal.view-modal.cancelButtonLabel',
    defaultMessage: 'Close modal',
    description: 'Label for Close button for the form permission configuration modal in view only mode.'
  },
  restrictionsLoadFailureDescription: {
    id: 'proforma-form-security.config-button.config-modal.view-modal.restrictionsLoadFailureDescription',
    defaultMessage: 'We couldn’t load restrictions on this page. Refresh the page and try again.',
    description: 'Message shown to the user when loading the restricted principals failed'
  },
  restrictionsModalCloseIconLabel: {
    id: 'proforma-form-security.config-button.config-modal.view-modal.restrictions-modal-close-icon-label',
    defaultMessage: 'Close modal',
    description: 'Label for the close icon within the form permissions view modal.'
  }
});